
    const eProtectIframeScript = document.createElement("script");
    eProtectIframeScript.src = "https://request.eprotect.vantivcnp.com/eProtect/js/eProtect-iframe-client3.min.js";
    eProtectIframeScript.async = true;
    document.body.appendChild(eProtectIframeScript);
  